module.exports = __webpack_public_path__ + "img/80.547e9156.png";